import type { AxiosRequestConfig } from 'axios';
import z from 'zod';

import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SyncAlertConfigDtoSchema } from './get-sync-alert-config';

const UpsertSyncAlertConfigRequestSchema = z.object({
  enabled: z.boolean(),
  alertEmails: z.array(z.string().email()),
  slackWebhookUrl: z.string().nullable(),
});

export type UpsertSyncAlertConfigRequest = z.infer<
  typeof UpsertSyncAlertConfigRequestSchema
>;

export const upsertSyncAlertConfig = (
  dto: UpsertSyncAlertConfigRequest,
  config?: AxiosRequestConfig
) => {
  const data = UpsertSyncAlertConfigRequestSchema.parse(dto);
  return api
    .put('/sync-alert-config', data, config)
    .then(responseContract(SyncAlertConfigDtoSchema));
};
